import gql from '@/services/gql';

export interface SearchResponse {
  user: Array<{
    [recordType: string]: {
      aggregate: {
        count: number;
      }
      nodes: Array<{
        id: string;
        name: string;
      }>;
    };
  }>;
}

const defaultWhere = `
  {
    _or: [
      { name: { _ilike: $value } },
      { notes: { _ilike: $value } }
    ]
  }
`;

const defaultQuery = (table: string) => `
  ${table}: ${table}s_aggregate(
    limit: $limit
    offset: $offset
    order_by: {
      name: asc
    }
    where: ${defaultWhere}
  ) {
    aggregate {
      count
    }
    nodes {
      id
      name
    }
  }
`;

const search = gql<SearchResponse>(`
  query Search (
    $limit: Int!
    $offset: Int!
    $value: String!
  ) {
    user {
      ${defaultQuery('component')}
      ${defaultQuery('material')}
      ${defaultQuery('product')}
      ${defaultQuery('vendor')}

      linesheet: linesheets_aggregate(
        limit: $limit
        offset: $offset
        order_by: {
          title: asc
        }
        where: {
          _or: [
            { title: { _ilike: $value } },
            { notes: { _ilike: $value } }
          ]
        }
      ) {
        aggregate {
          count
        }
        nodes {
          id
          name: title
        }
      }
    }
  }
`);

export default {
  search,
};
